import { TextField, Slider, Box, Tooltip, Typography } from "@mui/material";

import ErrorIcon from "@mui/icons-material/Error";
function ValueLabelComponent(props) {
  return (
    <Tooltip
      open={props.open}
      enterTouchDelay={0}
      placement="bottom"
      title={props.value}
    >
      {props.children}
    </Tooltip>
  );
}

export default function ComputationCurate({
  curate,
  question,
  updateHandler,
  disabled,
}) {
  const minVal = curate?.minVal ?? 0; // min value for computation item if fullQuestionEditable = 1
  const maxVal = curate?.maxVal ?? 100; // max value for computation item if fullQuestionEditable = 1
  const inputType = curate?.inputType ?? "iNumber"; //number field (iNumber) or slider field (iSlider) for computation item if fullQuestionEditable = 1
  const marks = [
    { value: minVal, label: `${minVal}` },
    { value: maxVal, label: `${maxVal}` },
  ];
  const error =
    Number(question.expressionString) < minVal ||
    Number(question.expressionString) > maxVal;
  const empty = question.expressionString === "";
  if (inputType === "iNumber")
    return (
      <Box display="flex" gap={1}>
        <TextField
          sx={{ width: 80 }}
          variant="standard"
          type="number"
          InputLabelProps={{
            shrink: true,
          }}
          value={question.expressionString}
          onChange={(e) =>
            updateHandler({ expressionString: `${e.target.value}` })
          }
          disabled={disabled}
          error={error}
        />
        {error ? (
          <Typography
            variant="body2"
            color="error"
            display={"flex"}
            alignItem="center"
            gap={"4px"}
            paddingTop={1}
          >
            <ErrorIcon fontSize="small" />{" "}
            {`Value should be between ${minVal} and ${maxVal}`}
          </Typography>
        ) : null}
      </Box>
    );
  if (inputType === "iSlider")
    return (
      <Box paddingLeft={2} paddingRight={2} paddingTop={1}>
        <Slider
          size="small"
          value={Number(question.expressionString)}
          min={minVal}
          max={maxVal}
          marks={marks}
          aria-label="Slider threshold"
          onChange={(e) =>
            updateHandler({ expressionString: `${e.target.value}` })
          }
          // custom tooltip component at bottom
          components={{
            ValueLabel: ValueLabelComponent,
          }}
          componentsProps={{ empty }}
          // don't show the tooltip if no value is set
          valueLabelDisplay={empty ? "off" : "on"}
          // don't show the thumb is no value is set
          sx={
            empty
              ? {
                  ".MuiSlider-thumb": {
                    display: "none",
                  },
                }
              : null
          }
        />
      </Box>
    );
  return <div></div>;
}
